import { Injectable } from '@angular/core';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { urlServices } from './collegeProfileUrls';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class CollegeProfileService {

  constructor(public http: HttpServiceService, public url: urlServices, public ced: encryptionService,
    public serverURL: ServerURLService) {

  }

  findAllAfflicationType() {
    return this.http.get(this.url.findAllAfflicationType);
  }

  findAllSeatType() {
    return this.http.get(this.url.findAllSeatType);
  }

  findAllIssueAuthority() {
    return this.http.get(this.url.findAllIssueAuthority);
  }

  findAllMedicalCollegeType() {
    return this.http.get(this.url.findAllCollegeType);
  }

  findAllMedicalHospitalType() {
    return this.http.get(this.url.findAllHospitalType);
  }

  findAllCollegeHospitalReq() {
    return this.http.get(this.url.findAllCollegeHospitalReq);
  }

  getEquipBySpecializations(specId: any) {
    var encryptedId = encodeURIComponent(this.ced.encryptAesToString(specId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.findAllEquipBySpecializations + "?specialization=" + encryptedId);
  }

  findAllLibraryAmenities() {
    return this.http.get(this.url.findAllLibraryAmenities);
  }

  findAllTotalBooksLibrary() {
    return this.http.get(this.url.findAllLibrayTotalBooks);
  }

  findAllEquipmentBdsProforma() {
    return this.http.get(this.url.findAllEquipmentBdsProforma);
  }

  findAllStudentAcademicActivities() {
    return this.http.get(this.url.findAllStudentAcademicActivities);
  }

  findAllTeachingLearningActivities() {
    return this.http.get(this.url.findAllStudentLearningActivities);
  }

  findAllLearningActivitiesByYear(obj: any) {
    return this.http.post(this.url.findAllLearningActivitiesByYear, obj);
  }

  findAllInfrastrucutreFacility() {
    return this.http.get(this.url.findAllInfrastrucutreFacility);
  }

  findAllLandDeedMaster() {
    return this.http.get(this.url.findAllLandDeedMaster);
  }

  // General Information
  saveCollegeGeneralInfo(generalInfo: any) {
    return this.http.post(this.url.saveCollegeGeneralInfo, generalInfo);
  }

  getGeneralInformationDetails(obj: any) {
    return this.http.post(this.url.getCollegeGeneralInfoDetails, obj);
  }
  GetCollegeGeneralInfoDetailsView(obj: any) {
    return this.http.post(this.url.GetCollegeGeneralInfoDetailsView, obj);
  }
  // Attached Hospital
  saveAttachedHospInfo(attachHospInfo: any) {
    return this.http.post(this.url.saveAttachedHospInfo, attachHospInfo);
  }

  getAttachedHospitalDetails(obj: any) {
    return this.http.post(this.url.getAttachedHospInfoDetails, obj);
  }
  GetAttachedHospInfoDetailsForView(obj: any) {
    return this.http.post(this.url.GetAttachedHospInfoDetailsForView, obj);
  }

  // Attached Hospital Proforma
  saveClinicalActivityProformaInfo(attachHospInfo: any) {
    return this.http.post(this.url.saveClinicalActivityProformaInfo, attachHospInfo);
  }
  //College Information Proforma
  saveProformaClgInfo(proformaCollegeInformation: any) {
    return this.http.post(this.url.saveProformaClgInfo, proformaCollegeInformation);
  }

  getClinicalActivityProformaInfoDetails(obj: any) {
    return this.http.post(this.url.getClinicalActivityProformaInfoDetails, obj);
  }

  // Construction and Planning
  saveConstructionPlanning(constructionDetailsOfLandDTO: any) {
    return this.http.post(this.url.saveConstructionPlanning, constructionDetailsOfLandDTO);
  }

  getConstructionPlanningDetails(obj: any) {
    return this.http.post(this.url.getConstructionPlanningDetails, obj);
  }
  GetConstructionPlanningDetailsForView(obj: any) {
    return this.http.post(this.url.GetConstructionPlanningDetailsForView, obj);
  }
  // Equipment Details
  saveEquipmentDetails(obj: any) {
    return this.http.post(this.url.saveEquipmentDetails, obj);
  }

  getEquipmentDetails(obj: any) {
    return this.http.post(this.url.getEquipmentDetails, obj);
  }
  GetEquipmentListForView(obj: any) {
    return this.http.post(this.url.GetEquipmentListForView, obj);
  }
  // Infrastructure Details
  saveInfrastructureDetails(obj: any) {
    return this.http.post(this.url.saveInfrastructureDetails, obj);
  }

  saveInfrastructureInfoList(obj: any) {
    return this.http.post(this.url.saveInfrastructureInfoList, obj);
  }

  GetInfrastructureInfoDetails(obj: any) {
    return this.http.post(this.url.GetInfrastructureInfoDetails, obj);
  }

  getInfrastructureDetails(obj: any) {
    return this.http.post(this.url.getInfrastructureInfoDetails, obj);
  }
  
  GetInfrastructureViewDetails(infrastructureDTO: any) {
    return this.http.post(this.url.GetInfrastructureViewDetails, infrastructureDTO);
  }

  getInfraSpecInfoDetails(obj: any) {
    return this.http.post(this.url.getInfraSpecInfoDetails, obj);
  }

  saveInfrastructureProformaDetails(infrastructureInfo: any) {
    return this.http.post(this.url.saveInfrastructureProformaDetails, infrastructureInfo);
  }

  getInfrastructureProformaDetails(obj: any) {
    return this.http.post(this.url.getInfrastructureProformaDetails, obj);
  }

  uploadFileInfrastructureProforma(formdata: any, Ids: any, proformaInfraId: any) {
    return this.http.post<any>(this.url.uploadFileInfrastructureProforma + "?Ids=" + Ids + "&proformaInfraId=" + proformaInfraId, formdata);
  }

  // Edit Equipment Details
  saveCourseEquipmentDetails(obj: any) {
    return this.http.post(this.url.saveCourseEquipmentDetails, obj);
  }

  // Save Equipment Proforma Details
  saveEquipmentProformaDetails(obj: any) {
    return this.http.post(this.url.saveEquipmentProformaDetails, obj);
  }

  getCourseEquipmentDetails(obj: any) {
    return this.http.post(this.url.getCourseEquipmentInfoDetails, obj);
  }
  GetEquipmentDetailsForView(courseEquipListId: any) {
    return this.http.post(this.url.GetEquipmentDetailsForView, courseEquipListId);
  }
  getEquipmentDetailsProforma(obj: any) {
    return this.http.post(this.url.getEquipmentInfoProforma, obj);
  }

  //Bank Details
  saveCollegeBankDetails(collegeBankDetailsDTO: any) {
    return this.http.post(this.url.saveCollegeBankDetails, collegeBankDetailsDTO);
  }

  getCollegeBankDetails(collegeId: any) {
    var encryptedId = encodeURIComponent(this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getCollegeBankDetails + "?encryptCollegeId=" + encryptedId);
  }
  GetCollegeBankDetailsForView(collegeBankDetailsDTO: any) {
    return this.http.post(this.url.GetCollegeBankDetailsForView, collegeBankDetailsDTO);
  }
  uploadFile(files: any, id, type: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      if (files[i].files != null && files[i].files != undefined)
        formdata.append('files', files[i].files);
    }
    return this.http.post<any>(this.url.generalInfoFileUpload + "?Id=" + id + "&type=" + type, formdata);
  }

  uploadFileGeneralInfo(files: any, id) {
    var formdata: FormData = new FormData();
    var columnNames: any = [];
    for (let i = 0; i < files.length; i++) {
      if (files[i].files != null && files[i].files != undefined)
        formdata.append('files', files[i].files);
      columnNames.push(files[i].documentType);
    }
    return this.http.post<any>(this.url.generalInfoFileUpload + "?generalInfoId=" + id + "&columnNames=" + columnNames, formdata);

  }

  uploadFileList(files: any, type: any, generalInfoId: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      if (files[i].files != null && files[i].files != undefined)
        formdata.append('files', files[i].files);
      formdata.append('detailsId', files[i].detailsId);
    }

    return this.http.post<any>(this.url.generalInfoFileUploadList + "?type=" + type + "&generalInfoId=" + generalInfoId, formdata);
  }

  uploadFileListGeneralInfo(formdata: any, Ids: any, tableNames: any, generalInfoId: any) {
    return this.http.post<any>(this.url.generalInfoFileUploadList + "?Ids=" + Ids + "&tableNames=" + tableNames + "&generalInfoId=" + generalInfoId, formdata);
  }

  CollegeBankDetailsFileUpload(bankDetailsDocument: any, bankDetailsId: any) {
    var formdata: FormData = new FormData();
    var columnNames: any = [];
    for (let i = 0; i < bankDetailsDocument.length; i++) {
      if (bankDetailsDocument[i].files != null && bankDetailsDocument[i].files != undefined)
        formdata.append('files', bankDetailsDocument[i].files);
      columnNames.push(bankDetailsDocument[i].columnName);
    }
    return this.http.post<any>(this.url.CollegeBankDetailsFileUpload + "?bankDetailsId=" + bankDetailsId + "&columnNames=" + columnNames, formdata);
  }

  CollegeInfrastructureFileUpload(infrastructureDocument: any, clgInfrastructureId: any) {
    var formdata: FormData = new FormData();
    var Ids: any = [];
    var columnNames: any = [];
    for (let i = 0; i < infrastructureDocument.length; i++) {
      if (infrastructureDocument[i].files != null && infrastructureDocument[i].files != undefined)
        formdata.append('files', infrastructureDocument[i].files);
      columnNames.push(infrastructureDocument[i].columnName);
    }
    return this.http.post<any>(this.url.InfrastructureDetailsFileUpload + "?clgInfrastructureId=" + clgInfrastructureId + "&columnNames=" + columnNames, formdata);
  }



  UploadBankDetailsStatement(formdata: any, Ids: any, tableNames: any) {
    return this.http.post<any>(this.url.UploadBankDetailsStatement + "?Ids=" + Ids + "&tableNames=" + tableNames, formdata);
  }

  ConstructionFileUpload(document: any, id: any) {
    var formdata: FormData = new FormData();
    var Ids: any = [];
    var columnNames: any = [];
    for (let i = 0; i < document.length; i++) {
      if (document[i].files != null && document[i].files != undefined)
        formdata.append('files', document[i].files);
      columnNames.push(document[i].columnName);
    }
    return this.http.post<any>(this.url.ConstructionFileUpload + "?documentId=" + id + "&columnNames=" + columnNames, formdata);
  }

  libraryFileUpload(document: any, id: any) {
    var formdata: FormData = new FormData();
    var Ids: any = [];
    var columnNames: any = [];
    for (let i = 0; i < document.length; i++) {
      if (document[i].files != null && document[i].files != undefined)
        formdata.append('files', document[i].files);
      columnNames.push(document[i].columnName);
    }
    return this.http.post<any>(this.url.libraryFileUpload + "?documentId=" + id + "&columnNames=" + columnNames, formdata);
  }

  UploadConstructionPlanning(constructionDocument: any) {
    var formdata: FormData = new FormData();
    var tableNames: any = [];
    var Ids: any = [];
    for (let i = 0; i < constructionDocument.length; i++) {
      if (constructionDocument[i].files != null && constructionDocument[i].files != undefined)
        formdata.append('files', constructionDocument[i].files);
        tableNames.push(constructionDocument[i].tableName);
        Ids.push(constructionDocument[i].Id);
    }    
    return this.http.post<any>(this.url.UploadConstructionPlanning + "?Ids=" + Ids + "&tableNames=" + tableNames, formdata);
  }

  UploadLibraryDetails(formdata: any, Ids: any, tableNames: any) {
    return this.http.post<any>(this.url.uploadLibraryDetails + "?Ids=" + Ids + "&tableNames=" + tableNames, formdata);
  }

  UploadConstructionPlanningMultiple(formdata: any) {
    return this.http.post(this.url.UploadConstructionPlanningMultiple, formdata);
  }

  UploadDentalStaff(formdata: any, Ids: any) {
    return this.http.post<any>(this.url.UploadDentalStaff + "?Ids=" + Ids, formdata);
  }

  UploadStaffPublication(formdata: any, Ids: any) {
    return this.http.post<any>(this.url.UploadStaffPublication + "?Ids=" + Ids, formdata);
  }

  uploadFileListAttachedHosp(formdata: any, Ids: any, tableNames: any, attachedHospId: any) {
    return this.http.post<any>(this.url.attachedHospDocumentUpload + "?Ids=" + Ids + "&tableNames=" + tableNames + "&attachedHospId=" + attachedHospId, formdata);
  }

  nonTeachingFileUploadList(Ids: any, formdata: any) {
    return this.http.post<any>(this.url.nonTeachingFileUploadList + "?Ids=" + Ids, formdata);
  }	

  // Library Details
  saveLibraryDetails(obj: any) {
    return this.http.post(this.url.saveLibraryDetails, obj);
  }

  getLibraryDetails(obj: any) {
    return this.http.post(this.url.getLibraryInfoDetails, obj);
  }
  
  getLibraryDetailsForView(obj: any) {
    return this.http.post(this.url.getLibraryInfoDetailsForView, obj);
  }

  saveLibraryProformaDetails(obj: any) {
    return this.http.post(this.url.saveLibraryProformaDetails, obj);
  }

  getLibraryProformaDetailsInfo(obj: any) {
    return this.http.post(this.url.getLibraryProformaDetailsInfo, obj);
  }

  // getSpecializationsByCourseId
  getSpecializations(courseId: any) {
    return this.http.get(this.url.getSpecializations + "?courseId=" + courseId);
  }

  getDesignations() {
    return this.http.get(this.url.getDesignations);
  }

  getStaffTypeList() {
    return this.http.get(this.url.getStaffTypeList);
  }

  saveDentalStaffDetails(obj: any) {
    return this.http.post(this.url.saveDentalStaffDetails, obj);
  }

  DentalStaffFileUpload(document: any, id: any) {
    var formdata: FormData = new FormData();
    var columnNames: any = [];
    for (let i = 0; i < document.length; i++) {
      if (document[i].files != null && document[i].files != undefined)
        formdata.append('files', document[i].files);
      columnNames.push(document[i].columnName);
    }
    return this.http.post<any>(this.url.DentalStaffFileUpload + "?documentId=" + id + "&columnNames=" + columnNames, formdata);
  }

  // Save Staff Proforma Details
  saveDentalStaffProforma(obj: any) {
    return this.http.post(this.url.saveDentalStaffProforma, obj);
  }

  // Get Staff  Proforma Details
  getDentalStaffProformaDetails(obj: any) {
    return this.http.post(this.url.getDentalStaffProformaDetails, obj);
  }
    // Get college Information Proforma Details
    getCollegeInfoProformaDetails(obj: any) {
      return this.http.post(this.url.getCollegeInfoProformaDetails, obj);
    }

  // getNonTeachingStaff
  GetNonTeachingStaffMstrView(collegeId: any) {
    var collegeIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.GetNonTeachingStaffMstrViewList + '?collegeIdEncr=' + collegeIdEncr);
  }
  GetNonTeachingStaffMstrListForView(nonTeachingStaffDTO: any) {
    return this.http.post(this.url.GetNonTeachingStaffMstrListForView, nonTeachingStaffDTO);
  }
  //Student Academic Activity
  saveStudentAcademicDetails(obj: any) {
    return this.http.post(this.url.saveStudentAcademicDetails, obj);
  }

  getStudentAcademicInfoDetails(obj: any) {
    return this.http.post(this.url.getStudentAcademicInfoDetails, obj);
  }

  saveStudentAcadmicListDetails(obj: any) {
    return this.http.post(this.url.saveStudentAcadmicListDetails, obj);
  }

  GetStudentAcademicListByCollege(studentActivityDashboardView: any) {
    return this.http.post(this.url.GetStudentAcademicListByCollege, studentActivityDashboardView);
  }

  //Student Academic Proforma
  saveStudentAcadmicProformaDetails(obj: any) {
    return this.http.post(this.url.saveStudentProformaDetails, obj);
  }

  getStudentAcadmicProformaInfoDetails(studentActivityDashboardView: any) {
    return this.http.post(this.url.getStudentProformaInfoDetails, studentActivityDashboardView);
  }

  //Teaching Learning Activity
  saveTeachingLearningDetails(obj: any) {
    return this.http.post(this.url.saveTeachingLearningDetails, obj);
  }

  getTeachingLearningInfoDetails(obj: any) {
    return this.http.post(this.url.getTeachingLearningInfoDetails, obj);
  }

  saveTeachingLearningListDetails(obj: any) {
    return this.http.post(this.url.saveTeachingLearningListDetails, obj);
  }

  getTeachingLearningList(teachingLearningDashboardView: any) {
    return this.http.post(this.url.getTeachingLearningListCollege, teachingLearningDashboardView);
  }
  //
  submitInspection(obj) {
    return this.http.post(this.url.submitInspection, obj);
  }
  //Teaching Learning Proforma
  saveTeachingLearningProformaDetails(obj: any) {
    return this.http.post(this.url.saveTeachingProformaDetails, obj);
  }

  getTeachingLearningProformaInfoDetails(teachingLearningDashboardView: any) {
    return this.http.post(this.url.getTeachingProformaInfoDetails, teachingLearningDashboardView);
  }

  savesubmitNonTeachingStaff(generalInfo: any) {
    return this.http.post(this.url.savesubmitNonTeachingStaff, generalInfo);
  }

  getNonTeachingStaffDetails(obj: any) {
    return this.http.post(this.url.getNonTeachingStaffDetails, obj);
  }

  getStaffDetailsList(obj: any) {
    return this.http.post(this.url.getStaffDetailsList, obj);
  }

  getStaffDesnDetails(id: any) {
    var staffDesIdEncr = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getStaffDesnDetails + "?staffDesIdEncr=" + staffDesIdEncr);
  }

  saveProformaSubmitNonTeachingStaff(staffInfo: any) {
    return this.http.post(this.url.saveProformaNonTeachingStaff, staffInfo);
  }

  getProformaNonTeachingStaffDetails(obj: any) {
    return this.http.post(this.url.getProformaNonTeachingStaff, obj);
  }

  //Dashboard 
  getDentalStaffList(DentalStaffDashboardView: any) {
    return this.http.post(this.url.getDentalStaffList, DentalStaffDashboardView);
  }

  getDentalStaffById(staffId: number) {
    return this.http.get(this.url.getDentalStaffById + '?staffId=' + staffId);
  }
  deletestaff(staffId: number) {
    return this.http.get(this.url.deleteStaffById + '?staffId=' + staffId);
  }
  GetDentalStaffForViewById(staffId: number) {
    return this.http.get(this.url.GetDentalStaffForViewById + '?staffId=' + staffId);
  }

  findByInfrastructure() {
    return this.http.get(this.url.getInfrastructure);
  }

  //Hostel Facility Details
  saveHostelFacilityDetails(obj: any) {
    return this.http.post(this.url.saveHostelFacilityDetails, obj);
  }

  getHostelFacilityDetails(obj: any) {
    return this.http.post(this.url.getHostelFacilityInfoDetails, obj);
  }


  public ageMaxDate() {
    var currentDate = new Date();
    var month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    var day = ("0" + currentDate.getDate()).slice(-2);
    return currentDate.getFullYear() - 19 + '-' + month + '-' + day
  }

  // Staff Assessment for Publications
  saveStaffAsesmentProforma(staffAssmtInfo: any) {
    return this.http.post(this.url.saveStaffAsesmentProforma, staffAssmtInfo);
  }

  getStaffAssesmentProformaDetails(obj: any) {
    return this.http.post(this.url.getStaffAssesmentProformaDetails, obj);
  }

  // Last Annual Admission Details for Specialty
  saveAnnualAdmissionProforma(annualAdmissionInfo: any) {
    return this.http.post(this.url.saveAnnualAdmissionProforma, annualAdmissionInfo);
  }

  getAnnualAdmissionProformaDetails(obj: any) {
    return this.http.post(this.url.getAnnualAdmissionProformaDetails, obj);
  }

  DeleteCollegeNonTeachingStaffByNonTeachStaffId(nonTeachStaffId: any) {
    return this.http.get(this.url.DeleteCollegeNonTeachingStaffByNonTeachStaffId + "?nonTeachStaffId=" + nonTeachStaffId);
  }

  //Designation Wise Staff Count
  getStaffCountByDesignation(collegeId: any, academicYear: any) {
    const obj = {
      academicYear: academicYear,
      collegeId: this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getStaffCountByDesignation, obj);
  }

  // getMDSStudentListByCollegeAndAcademicYear
  getMDSStudentList(collegeId: any, academicYear: any, courseId: any, specializationId: any) {
    const obj = {
      collegeIdEncr: this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString(),
      academicYearEncr: this.ced.encryptAesToString(academicYear, this.serverURL.secretKey).toString(),
      courseIdEncr: this.ced.encryptAesToString(courseId, this.serverURL.secretKey).toString(),
      specializationIdEncr: this.ced.encryptAesToString(specializationId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getMDSStudentList, obj);
  }

  //Self Assessment
  submitSelfAssessmentByCollege(obj) {
    return this.http.post(this.url.submitSelfAssessmentByCollege, obj);
  }

  getSelfAssessmentByCollege(obj) {
    return this.http.post(this.url.getSelfAssessmentByCollege, obj);
  }

  //Proforma Details

 // get Submit Inspection
  getSubmitInspection(obj) {
    return this.http.post(this.url.getSubmitInspection, obj);
  }

  GetInspectionScheduleView(userId : any){
    return this.http.get(this.url.GetInspectionScheduleView +'?userId=' + userId);
  }
  
  GetInspectionProformaDetailsId(data: any) {
    return this.http.post(this.url.GetInspectionProformaDetailsId, data);
  }
  
  GenerateDeficiencyReportPDF(data: any) {
    return this.http.post(this.url.GenerateDeficiencyReportPDF, data);
  }
  inspectionReportView(data: any) {
    return this.http.post(this.url.inspectionReportView, data);
  }
  getInspectionDateByCollegeId(collegeId: any, academicYear: string) {
    var encryptedId = encodeURIComponent(this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString());

    return this.http.get(this.url.getInspectionDateByCollegeId + "?encryptCollegeId=" + encryptedId + "&academicYear=" + academicYear);
  }

}